<ng-container *ngIf="panels$ | async as panels">
  <h3 class="translations-title">
    {{ 'TRANSLATION' | translate }}
  </h3>

  <nz-collapse>
    <nz-collapse-panel
      *ngFor="let panel of panels; trackBy: trackPanel"
      [nzActive]="panel.active"
      [nzHeader]="panel.header"
      [nzExtra]="panel.type === TranslationTypeEnum.AI ? newTag : undefined"
    >
      <nz-alert
        *ngIf="panel.type === TranslationTypeEnum.AI"
        class="ai-voice-alert"
        nzType="warning"
        nzShowIcon
        [nzMessage]="'USER_REQUESTS.TRANSLATION_PANELS.UPDATED_VOICE' | translate"
      ></nz-alert>

      <ng-container *ngFor="let panelLang of panel.langs; trackBy: trackLangGroup">
        <div class="translation-lang-card">
          <div class="translation-lang-header">
            {{ panelLang.lang | uppercase | translate }}
          </div>

          <div class="translation-items" *ngIf="panelLang.text.length">
            <div
              class="translation-item"
              *ngFor="let langText of panelLang.text; trackBy: trackTranslationItem"
            >
              <div class="translation-block">
                <p
                  class="translation-message"
                  *ngIf="langText.message"
                  [innerHtml]="langText.message"
                ></p>

                <div class="translation-feedback">
                  <app-lot-translations-feedback
                    *ngIf="lotType === LotTypeEnum.Auto"
                    [isManager]="isManager"
                    [translationId]="langText.id"
                    [likesCount]="langText.likesCount"
                    [dislikesCount]="langText.dislikesCount"
                    [feedback]="langText.currentUserTranslationFeedback"
                    (completed)="onActionCompleted()"
                  ></app-lot-translations-feedback>
                </div>
              </div>
            </div>
          </div>

          <div class="translation-items" *ngIf="panelLang.voice.length">
            <div
              class="translation-item"
              *ngFor="let langVoice of panelLang.voice; trackBy: trackTranslationItem"
            >
              <div class="translation-block">
                <nz-row nzAlign="middle" [nzGutter]="[24, 12]">
                  <nz-col nzFlex="420px">
                    <audio
                      #audio
                      *ngIf="langVoice.file"
                      [src]="langVoice.file?.fullPath"
                      controls
                    ></audio>
                  </nz-col>

                  <nz-col nzFlex="1 1 auto">
                    <app-lot-translations-feedback
                      *ngIf="lotType === LotTypeEnum.Auto"
                      [isManager]="isManager"
                      [translationId]="langVoice.id"
                      [likesCount]="langVoice.likesCount"
                      [dislikesCount]="langVoice.dislikesCount"
                      [feedback]="langVoice.currentUserTranslationFeedback"
                      (completed)="onActionCompleted()"
                    ></app-lot-translations-feedback>
                  </nz-col>
                </nz-row>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <nz-tag
        *ngIf="panel.type === TranslationTypeEnum.AI"
        class="ai-translation-message"
        nzColor="blue"
      >
        {{ 'USER_REQUESTS.AI_TRANSLATION.INFO' | translate }}
      </nz-tag>
    </nz-collapse-panel>
  </nz-collapse>
</ng-container>

<ng-template #newTag>
  <nz-tag nzColor="purple">NEW!</nz-tag>
</ng-template>
